import { render, staticRenderFns } from "./DashboardPage.vue?vue&type=template&id=25b4b1d2&scoped=true"
import script from "./DashboardPage.vue?vue&type=script&lang=js"
export * from "./DashboardPage.vue?vue&type=script&lang=js"
import style0 from "./DashboardPage.vue?vue&type=style&index=0&id=25b4b1d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b4b1d2",
  null
  
)

export default component.exports